<template>
    <div class="container">
        <div class="flex-1 mt-9">
            <div v-show="$appUtil.checkPermission('FLEXBEN_EDIT')">
                <DesignSegmentedToggle
                    v-model="targetType"
                    :options="targetTypeOptions"
                    :size="'LG'"
                    @change="onTargetTypeChange"
                />
            </div>
            <!-- search options____________________________________________________________________________________________________________________________________________________________________________________________-->
            <div class="w-full max-w-7xl mt-5">
                <div class="flex justify-between items-center gap-5 flex-wrap">
                    <div class="flex justify-between items-center gap-5">
                        <DesignDropdownSelect
                            v-model="selectData.departmentSeq"
                            :options="departmentOptions"
                            size="LG"
                            :width="'w-[186px]'"
                            placeholder="All Departments"
                            :useDefaultMsg="true"
                            @change="onSearchEvent(0)" />
                        <DesignDropdownSelect
                            v-show="targetType === 'EMPLOYEE'"
                            v-model="selectData.jobTitleSeq"
                            :options="jobTitleOptions"
                            size="LG"
                            :width="'w-[186px]'"
                            placeholder="All Tiers"
                            :useDefaultMsg="true"
                            @change="onSearchEvent(0)" />
                        <DesignDropdownSelect
                            v-show="targetType === 'EMPLOYEE'"
                            v-model="selectData.employmentType"
                            :options="employmentTypeOptions"
                            size="LG"
                            :width="'w-[186px]'"
                            :placeholder="'All Contract Type'"
                            :useDefaultMsg="true"
                            :height12="true"
                            @change="onSearchEvent(0)" />
                        <ElementsSearchBar
                            v-model="employeeNameForSearch"
                            :options="targetType=='EMPLOYEE'? employeeOptions : subAdminOptions"
                            :height12="true"
                            :width60="true"
                            :placeholder="employeePlaceholder"
                            @searchEvent="onSearchEvent(0)"
                            ref="employeeSearchBar"
                            :optionClickEvent="true"
                            :hasSearchButton="true" />
                    </div>

                    <DesignButton 
                        btnText="Download Excel" 
                        btnSize="LG" btnType="QUATERNARY" :btnDisabled="false"
                        @click-event="clickExcelDownload" 
                    />

                    <!--for aboitiz - cost center____________________________________________________________________________________________________________________________________________________________________________________________-->
                    <div v-show="isAboitiz && targetType === 'EMPLOYEE'" class="flex w-full border-t border-gray-300 my-2"></div>
                    <ElementsSelectSearchBar
                        v-show="isAboitiz && targetType === 'EMPLOYEE'"
                        v-model="selectSearchBar"
                        @searchEvent="fetchPointBalance(0)"
                        :height12="true"
                        :width60="true"
                        :useDefaultMsg="true"
                        :selectTypeList="selectOptionList"
                        :selectPlaceholder="selectSearchPlaceholder"
                        :selectDisable="true"
                        :fixedSelectVal="fixedSelectVal"
                        textPlaceholder="Search Cost Center"
                        ref="employeeSelectSearchBar"
                        :optionClickEvent="true"
                        :hasSearchButton="true" />

                    <ElementsNotification v-model="showExcelDisableNoti" notificationMsg="There are no downloadable history" :warning="true" />
                </div>
            </div>

            <!--EMPLOYEE _________________________________________________________________________________________________________________________________________________________________________________________________________________________-->
            <div v-show="targetType === 'EMPLOYEE'" id="employees" class="mt-3 w-full max-w-7xl">
                <table class="w-full table-fixed border border-gray-300 rounded-lg bg-white font-inter-heading-19">
                    <colgroup>
                        <col style="width: 3rem">
                        <col style="width: 12rem">
                        <col style="width: 12rem">
                        <col style="width: 12rem">
                        <col style="width: 12rem">
                        <col style="width: 12rem">
                        <col style="width: 12rem">
                        <template v-if="isAboitiz">
                            <col style="width: 12rem">
                        </template>
                    </colgroup>
                    <thead class="border-b border-gray-300 text-gray-600 rounded-t-lg bg-background-basic-2">
                        <tr>
                            <th scope="col" class="py-4 pl-4 font-inter-heading-19 pr-2 text-center">No</th>
                            <th scope="col" class="py-4 px-2 font-inter-heading-19 text-center">Name</th>
                            <th scope="col" class="py-4 px-2 font-inter-heading-19 text-center">Department</th>
                            <th scope="col" class="py-4 px-2 font-inter-heading-19 text-center">Tier</th>
                            <th scope="col" class="py-4 px-2 font-inter-heading-19 text-center">Available<br/>Points</th>
                            <th scope="col" class="py-4 px-2 font-inter-heading-19 text-center">Contract<br/>Type</th>
                            <th scope="col" class="py-4 pl-2 font-inter-heading-19 pr-4 text-center">Latest<br/>Transfer</th>
                            <th v-if="isAboitiz" scope="col" class="py-4 pl-2 pr-4 text-center">Cost<br/>Center</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(data, index) in pointList" :key="index" :class="{ 'bg-slate-50': index % 2 !== 0 }" class="bg-white">
                            <td class="font-inter-heading-20 py-2.5 pl-4 pr-2 text-sm font-normal text-center">
                                {{ index + 1 + indexNo }}
                            </td>
                            <td class="font-inter-heading-20 px-2 py-2">
                                <div class="flex items-center gap-2">
                                    <StatusCircle :status-code="data.employeeStatus" />
                                    <div class="font-semibold">
                                        <span class="block line-clamp-2 break-words">{{ $validateUtil.emptyValueToDash(data.employeeName) }}</span>
                                    </div>
                                </div>
                            </td>
                            <td class="font-inter-heading-20 px-2 text-center">
                                <span class="block line-clamp-2 break-words">
                                    {{ $validateUtil.emptyValueToDash(data.departmentName) }}
                                </span>
                            </td>
                            <td class="font-inter-heading-20 px-2 text-center">
                                <span class="block line-clamp-2 break-words">
                                    {{ $validateUtil.emptyValueToDash(data.jobTitleName) }}
                                </span>
                            </td>
                            <td class="font-inter-heading-20 px-2 text-center">
                                <span class="block line-clamp-2 break-words">
                                    {{ $validateUtil.numberWithCommas(data.walletEmployeeMileage) }}
                                </span>
                            </td>
                            <td class="font-inter-heading-20 px-2 text-center">
                                <span class="block line-clamp-2 break-words">
                                    {{ $validateUtil.emptyValueToDash(getDisplayTextOfEmploymentType(data.employmentType)) }}
                                </span>
                            </td>
                            <td class="font-inter-heading-20 px-2 text-center">
                                <div v-html="$dateFormatUtil.convertDateTimeToMMddyyyyHHmm(data.latestReceivedTransferDatetime)"/>
                            </td>
                            <td v-if="isAboitiz" class="px-2 text-center font-inter-heading-20 ">
                                <span class="block line-clamp-2 break-words">
                                    {{ $validateUtil.emptyValueToDash(data.costCenterName) }}
                                </span>
                            </td>
                        </tr>
                        <tr v-if="pointList.length === 0">
                            <td :colspan="isAboitiz ? 8 : 7" class="py-16 text-center text-content-basic-3 text-sm">
                                No employees found.
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="w-full h-28 flex justify-center items-center">
                    <ElementsPagination
                        v-model="currentPage"
                        :totalContent="pointCount"
                        :contentsPerPage="limit"
                        @clickPage="afterClickPage"
                    />
                </div>
            </div>

            <!--SUB-ADMIN ____________________________________________________________________________________________________________________________________________________________________________________________-->
            <div v-show="targetType === 'SUB_ADMIN'" id="employees" class="mt-3 w-full max-w-7xl">
                <div class="mt-5 bg-white border rounded-lg">
                    <table class="w-full table-fixed">
                        <colgroup>
                            <col style="width: 11.5rem">
                            <col style="width: 7.5rem">
                            <template v-for="i in walletColIndexes" :key="'cg-'+i">
                                <col style="width: 7.5rem">
                            </template>
                            <col style="width: 7.5rem">
                            <col style="width: 7.5rem">
                        </colgroup>
                        <thead class="text-gray-600 bg-background-basic-2 rounded-t-lg">
                            <tr>
                                <th class="px-6 py-3 text-center font-inter-heading-19 rounded-tl-lg" rowspan="2">Name</th>
                                <th class="px-6 py-3 text-center font-inter-heading-19" rowspan="2">Assigned <br/> Department</th>
                                <th v-for="i in walletColIndexes" :key="'h-'+i" class="px-3 py-3 font-inter-heading-19">
                                    <span class="block">Wallet {{ i + 1 }}</span>
                                    <span class="inline-block w-fit max-w-[6.25rem] px-1 py-0.5 mt-1 rounded-01 text-center truncate border text-gray-600 border-border-basic-2 bg-white font-inter-caption-2">
                                        {{ walletCategoryList[i]?.walletCategoryName || '-' }}
                                    </span>
                                </th>
                                <th class="px-3 py-3 font-inter-heading-19" rowspan="2">Total Balance</th>
                                <th class="px-3 py-3 font-inter-heading-19" rowspan="2">Latest<br/>Transfer</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="subAdminOverviewList.length === 0">
                                <td :colspan="4 + walletColIndexes.length" class="py-16 text-center text-gray-400 font-inter-heading-20">
                                    <div>No result found.</div>
                                </td>
                            </tr>
                            <tr v-else v-for="subAdminOverview in subAdminOverviewList" :key="subAdminOverview.subAdminSeq" class="border-t">
                                <td class="px-6 py-4 align-middle">
                                    <div class="font-medium flex items-center gap-3 font-inter-heading-20">
                                        <StatusCircle statusCode="ACTIVE" />
                                        <div>
                                            <div class="line-clamp-2 break-words">{{ subAdminOverview.subAdminName }}</div>
                                            <div class="font-inter-caption-2 text-gray-500 line-clamp-2 break-words">{{ subAdminOverview.subAdminDepartmentName }}</div>
                                        </div>
                                    </div>
                                </td>
                                <td class="font-inter-heading-20 px-6 py-4 align-middle">
                                    <div class="flex justify-center items-center gap-2 h-full">
                                        <button type="button" class="p-1 rounded hover:bg-background-basic-2 inline-flex items-center gap-2"
                                                @click="onClickViewAssignedDepartments(subAdminOverview)">
                                            <span>{{ subAdminOverview.assignedDepartmentCount }}</span>
                                            <ChevronRightIcon :width="16" :height="16" color="text-content-basic-2" weight="REGULAR" />
                                        </button>
                                    </div>
                                </td>
                                <td v-for="i in walletColIndexes" :key="'r-'+subAdminOverview.subAdminSeq+'-'+i" class="px-3 py-4 align-middle text-center">
                                    {{ formatPoints(getWalletAmount(subAdminOverview, i)) }}
                                </td>
                                <td class="font-inter-heading-20 px-3 py-4 align-middle text-center">{{ formatPoints(subAdminOverview.totalBalance) }}</td>
                                <td class="font-inter-heading-20 px-3 py-4 align-middle text-center">
                                    <div v-html="$dateFormatUtil.convertDateTimeToMMddyyyyHHmm(subAdminOverview.latestReceivedTransferDatetime)"/>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot v-if="subAdminOverviewList.length > 0">
                            <tr class="text-blue-600 border-t">
                                <td class="font-inter-heading-20 px-5 py-3 text-center" colspan="1">Total</td>
                                <td class="font-inter-heading-20 px-5 py-3 text-center" colspan="1"></td>
                                <td v-for="i in walletColIndexes" :key="'t-'+i" class="px-3 py-3 text-center">
                                    {{ formatPoints(walletTotals[i]) }}</td>
                                <td class="font-inter-heading-20 px-3 py-3  text-center">{{ formatPoints(grandTotal) }}</td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>

        </div>
    </div>
    <!-- ____________________________________________________________________________________________________________________________________________________________________________________________-->
    <Teleport to="body">
        <AppPopup
            v-model="showAssignedDeptPopup"
            :name="`Assigned Departments - ${popupSubAdminName}`"
            :buttonText="null"
            :width800="false"
            :noneOverflowAuto="false"
        >
            <div class="max-w-[600px]">
                <div v-if="((popupSubAdmin?.assignedDepartments?.length) || 0) === 0" class="px-5 py-6 text-content-basic-3">
                    No departments assigned.
                </div>
                <div v-else v-for="(dep, index) in (popupSubAdmin?.assignedDepartments || [])" :key="index"
                    class="px-5 py-3 flex items-center"
                    :class="{ 'bg-background-basic-2': index % 2 === 0, 'bg-background-basic-1': index % 2 === 1 }">
                    <div class="font-inter-heading-19 text-content-basic-1 truncate">
                        {{ dep.assignedDepartmentName }}
                    </div>
                </div>
            </div>
        </AppPopup>
    </Teleport>
</template>

<script>
import DesignSegmentedToggle from '@/components/design-system/design-segmented-toggle.vue';
import ElementsNotification from '@/components/elements/ElementsNotification.vue';
import ElementsSelectSearchBar from '@/components/elements/ElementsSelectSearchBar';
import DesignButton from '@/components/design-system/design-button.vue';
import DesignDropdownSelect from '@/components/design-system/design-dropdown-select.vue';
import ElementsDateSearchPack from '@/components/elements/ElementsDateSearchPack.vue';
import ElementsPopupDownloadExcel from '@/components/elements/ElementsPopupDownloadExcel.vue';
import ElementsSearchBar from '@/components/elements/ElementsSearchBar.vue';
import ElementsPagination from '@/components/elements/ElementsPagination.vue';
import StatusCircle from '@/components/employee/status-circle/status-circle';
import {CommonDataFormatUtil} from "@/plugins/app-util";
import { getAboitizInfo } from '@/plugins/app-pre-init';
import AppPopup from '@/components/AppPopup.vue';
import ChevronRightIcon from '@/components/design-system/icon/chevron-right.vue';
import { contractType } from '@/assets/data/optionData.js';

export default {
    components: {
        DesignSegmentedToggle,
        ElementsNotification,
        ElementsSelectSearchBar,
        DesignButton,
        ElementsPagination,
        StatusCircle,
        DesignDropdownSelect,
        ElementsDateSearchPack,
        ElementsPopupDownloadExcel,
        ElementsSearchBar,
        AppPopup,
        ChevronRightIcon
    },
    data() {
        return {
            targetType: 'EMPLOYEE',
            targetTypeOptions: [
                { text: 'Employee', value: 'EMPLOYEE' },
                { text: 'Sub-admin', value: 'SUB_ADMIN' },
            ],
            pointList: [],
            pointCount: 0,
            limit: 10,
            offset: 0,
            currentPage: null,
            indexNo: 0,

            subAdminOverviewList: [],
            walletCategoryList: [],
            walletColIndexes: [],
            walletTotals: [],
            grandTotal: 0,

            transactionTypeOptions: [
                { text: 'Type', value: null },
                { text: 'Top up', value: 'TOPUP_FROM_HRFLEX' },
                { text: 'Deduct', value: 'DEDUCT_TO_HRFLEX' },
                { text: 'Transfer', value: 'TRANSFER_TO_EMPLOYEE' },
                { text: 'Withdraw', value: 'DEDUCT_FROM_EMPLOYEE' },
            ],

            // for aboitiz (cost center)
            aboitizSeq: getAboitizInfo().companySeq,
            companySeq: sessionStorage.getItem("companySeq"),
            isAboitiz: false,

            // search controls used in template
            selectData: {
                limit: 10,
                offset: 0,
                departmentSeq: null,
                jobTitleSeq: null,
                employmentType: null,
                employeeSeqList: [],
                startSearchDate: null,
                endSearchDate: null,
                schType: null,
                schKeyword: null,
            },
            
            employeeOptions: [],
            subAdminOptions : [],
            
            employeeNameForSearch: null,
            departmentOptions: [],
            jobTitleOptions: [],
            employmentTypeOptions: contractType,
            employeePlaceholder: 'Search Employees',
            showExcelDisableNoti: false,
            selectSearchBar: '',
            selectSearchPlaceholder: 'Search Type',
            selectOptionList: [
                { value: 'COST_CENTER', text: 'Cost Center' },
                { value: 'BUSINESS_UNIT', text: 'Business Unit' },
            ],
            fixedSelectVal: {
                value: 'COST_CENTER',
                text: 'Cost Center',
            },
            showAssignedDeptPopup : false,
            popupSubAdminName : '',
            popupSubAdmin: null,

            scrollYBackup: 0

        };
    },
    computed: {
        // 여기에 모달이 더 있으면 || 로 추가
        isAnyPopupOpen() {
            return this.showAssignedDeptPopup;
        },
    },
    watch: {
        isAnyPopupOpen(val) {
            if (val) {
                this.lockBodyScroll();
            } else {
                this.unlockBodyScroll();
            }
        },
    },
    mounted() {
        const self = this;
        self.fetchPointBalance(0, true);
        self.getEmployeeOptions();
        self.getDepartmentOptions();
        self.getJobTitleOptions();
        self.getWalletCategoryList();
    },
    beforeMount() {
        const self = this;
        self.isAboitiz = self.aboitizSeq == self.companySeq;
        // self.fetchPointBalance(0);
    },
    methods: {
        lockBodyScroll() {
            // 현재 스크롤 위치 저장
            this.scrollYBackup = window.scrollY || document.documentElement.scrollTop || 0;

            // 레이아웃 점프 방지 및 스크롤 잠금
            document.body.style.position = 'fixed';
            document.body.style.top = `-${this.scrollYBackup}px`;
            document.body.style.left = '0';
            document.body.style.right = '0';
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden'; // 보조(데스크톱)
        },
        unlockBodyScroll() {
            // 원복
            const y = this.scrollYBackup || 0;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.left = '';
            document.body.style.right = '';
            document.body.style.width = '';
            document.body.style.overflow = '';

            // 저장해 둔 위치로 복귀
            window.scrollTo(0, y);
        },
        onSearchEvent(offset = 0){
            const self = this;
            if (self.targetType === 'EMPLOYEE') {
                self.fetchPointBalance(offset);
                return;
            } 
            
            if (self.targetType === 'SUB_ADMIN') {
                self.fetchSubAdminOverview();
                return;
            }
        },
        onTargetTypeChange(newVal) {
            const self = this;
            if (newVal === 'EMPLOYEE') {
                self.selectData.limit = 10;
                self.selectData.offset = 0;
                self.selectData.departmentSeq = null;
                self.selectData.jobTitleSeq = null;
                self.selectData.employmentType = null;
                self.selectData.startSearchDate = null;
                self.selectData.endSearchDate = null;
                self.selectData.schType = null;
                self.selectData.schKeyword = null;
                self.employeeNameForSearch = null;
                self.fetchPointBalance(0, true);
            } else if (newVal === 'SUB_ADMIN') {
                self.selectData.departmentSeq = null;
                self.employeeNameForSearch = null;
                self.fetchSubAdminOverview(true);
            }
        },
        formatPoints(v) {
            if (v == null || isNaN(v)) return '-';
            try { return new Intl.NumberFormat().format(v) + 'P'; } catch { return v + 'P'; }
        },
        getDepartmentOptions() {
            // Departments
            const self = this;

            const url = self.$api('uri', 'get-department');
            const json_query = JSON.stringify({
                showRootNode: true,
                menuAccessLevelCode: "FLEXBEN_ACCESS_LEVEL",
            });
            self.$axios.get(url, { params: { json_query } }).then((res) => {
                const options = res.data.data.list.map((dep) => ({
                    text: dep.departmentName,
                    value: dep.departmentSeq,
                }));

                self.departmentOptions.push(...options);
            });
        },
        getJobTitleOptions() {
            // Tiers
            const self = this;

            const json_query = JSON.stringify({
                limit: -1,
                offset: 0,
            });
            const url = self.$api('uri', 'get-jobTitle');
            self.$axios.get(url, { params: { json_query } }).then((res) => {
                const options = res.data.data.list.map((title) => ({ text: title.jobTitleName, value: title.jobTitleSeq }));
                self.jobTitleOptions.push(...options);
            });
        },
        getEmployeeOptions() {
            const self = this;

            // point balance는 resign한 직원제외후 검색된다
            let url = self.$api('uri', 'get-employee-all-out-resigned')
            const json_query = JSON.stringify({
                limit: -1,
                offset: 0,
            });

            self.$axios
                .get(url, { params: { json_query } })
                .then((res) => {
                    self.employeeOptions = res.data.data.list.map((emp) => ({ text: emp.employeeName, value: emp.employeeSeq }));
                })
                .catch((err) => {
                    console.error('err : ', err);
                });
        },
        getWalletCategoryList() {
            const self = this;
            const url = self.$api('uri', 'get-wallet-category-list');
            self.$axios
                .get(url)
                .then((res) => {
                    self.walletCategoryList = res.data?.data?.list ?? [];
                    // limit to 5 columns like SubAdminSetting and build indexes [0..N-1]
                    const count = Math.min(self.walletCategoryList.length || 0, 5);
                    self.walletColIndexes = Array.from({ length: count }, (_, i) => i);
                    // reset totals when categories change
                    self.walletTotals = Array.from({ length: count }, () => 0);
                    self.grandTotal = 0;
                })
                .catch((err) => {
                    console.error('err : ', err);
                });
        },
        getDisplayTextOfEmploymentType : CommonDataFormatUtil.employmentTypeFormat,
        afterClickPage(offset) {
            const self = this;
            self.indexNo = offset;
            self.fetchPointBalance(offset);
        },
        getTransactionName(transactionType) {
            const self = this;
            if( !transactionType ) return '-';

            let transactionName = '';
            transactionName = self.transactionTypeOptions.find((type) => type.value == transactionType).text;

            return transactionName;
        },
        getPointList(list, count, currentPage, indexNo){
            const self = this;
            self.pointList = list;
            self.pointCount = count;
            self.currentPage = currentPage;
            self.indexNo = indexNo;
        },
        downloadPointBalanceEmployee(){
            const self = this;
            if (!self.pointList || self.pointList.length === 0) {
                self.showExcelDisableNoti = true;
                return;
            }

            let schType = null;
            let schKeyword = null;
            if (self.isAboitiz) {
                const selectRef = self.$refs.employeeSelectSearchBar;
                const vals = selectRef && selectRef.getSearchedValues ? selectRef.getSearchedValues() : null;
                if (vals) {
                    schType = vals.schType;
                    schKeyword = vals.schKeyword;
                }
            }

            const sendData = {
                limit: -1,
                offset: 0,
                departmentSeq: self.selectData.departmentSeq,
                jobTitleSeq: self.selectData.jobTitleSeq,
                employmentType: self.selectData.employmentType,
                employeeSeqList: self.$refs.employeeSearchBar.getSearchedValues(),
                schType,
                schKeyword,
            };
            const json_query = JSON.stringify(sendData);
            const url = self.$api('uri', 'get-point-balance-file');
            self.$axios
                .get(url, { params: { json_query } })
                .then((res) => {
                    const downloadLink = res?.data?.data?.excelFilePath;
                    if (downloadLink) {
                        const aElem = document.createElement('a');
                        aElem.href = downloadLink;
                        aElem.click();
                    }
                })
                .catch((err) => {
                    console.error('excel download error:', err);
                });
        },
        downloadPointBalanceSubAdmin() {
            const self = this;
            const url = self.$api("uri", "get-point-balance-file-sub");
            const sendData = {
                departmentSeq: self.selectData.departmentSeq,
                employeeSeqList: self.$refs.employeeSearchBar.getSearchedValues(),
            };
            const json_query = JSON.stringify(sendData);
            self.$axios.get(url, { params : { json_query }})
            .then((res) => {
                    const downloadLink = res?.data?.data?.excelFilePath;
                    if (downloadLink) {
                        const aElem = document.createElement('a');
                        aElem.href = downloadLink;
                        aElem.click();
                    }
                })
                .catch((err) => {
                    console.error('excel download error:', err);
                });
        },
        clickExcelDownload() {
            const self = this;
            if(self.targetType === 'EMPLOYEE'){
                self.downloadPointBalanceEmployee();
                return;
            }

            if(self.targetType === 'SUB_ADMIN'){
                self.downloadPointBalanceSubAdmin();
                return;
            }
        },
        fetchPointBalance(offset = 0) {
            const self = this;
            self.selectData.offset = offset;
            self.selectData.employeeSeqList = self.$refs.employeeSearchBar.getSearchedValues();

            // aboitiz select-search (optional)
            let schType = null;
            let schKeyword = null;
            if (self.isAboitiz) {
                self.selectData.schType = self.$refs.employeeSelectSearchBar.getSearchedValues()?.schType;
                self.selectData.schKeyword = self.$refs.employeeSelectSearchBar.getSearchedValues()?.schKeyword;
            }

            const url = self.$api('uri', 'get-point-balance');
            const json_query = JSON.stringify(self.selectData);
            self.$axios
                .get(url, { params: { json_query } })
                .then((res) => {
                    const payload = res?.data?.data || {};
                    self.pointList = payload.list || [];
                    self.pointCount = payload.count ?? payload.total ?? 0;
                    self.currentPage = offset ? offset / self.selectData.limit + 1 : 1;
                })
                .catch((err) => {
                    console.error('fetchPointBalance error:', err);
                    self.pointList = [];
                    self.pointCount = 0;
                });
        },
        fetchSubAdminOverview(init = false) {
            const self = this;
            const url = self.$api('uri', 'get-point-balance-list-sub');
            
            let sendData = {};
            if(!init){
                sendData = {
                    departmentSeq: self.selectData.departmentSeq,
                    employeeSeqList : self.$refs.employeeSearchBar.getSearchedValues()
                };
            }
            console.log({init, sendData}, self.subAdminOptions)
            const json_query = JSON.stringify(sendData);
            return self.$axios
                .get(url, { params : { json_query }})
                .then((res) => {
                    self.subAdminOverviewList = res.data?.data?.list ?? [];
                    if(init){
                        self.subAdminOptions = self.subAdminOverviewList.map((sub)=>({text: sub.subAdminName, value: sub.subAdminSeq}))
                    }
                    // After list loads, recompute wallet totals
                    self.computeWalletTotals();
                })
                .catch((err) => {
                    console.error('getSubAdminOverview error', err);
                });
        },
        getWalletAmount(row, walletIndex) {
            try {
                const cat = this.walletCategoryList?.[walletIndex];
                if (!cat) return 0;
                const catSeq = cat.walletCategorySeq;
                const w = row.wallets.find(w => w.walletCategorySeq == catSeq);
                return w.walletSubAdminMileage ?? 0;
            } catch {
                return 0;
            }
        },
        // Compute per-column totals and grand total for sub-admin view
        computeWalletTotals() {
            const count = this.walletColIndexes?.length || 0;
            this.walletTotals = Array.from({ length: count }, (_, i) => {
                return (this.subAdminOverviewList || []).reduce((sum, row) => sum + this.getWalletAmount(row, i), 0);
            });
            this.grandTotal = this.walletTotals.reduce((a, b) => a + b, 0);
        },
        onClickViewAssignedDepartments(subAdminOverview) {
            if (!subAdminOverview) return;
            this.popupSubAdminName = subAdminOverview.subAdminName || '';
            this.popupSubAdmin = subAdminOverview;
            this.showAssignedDeptPopup = true;
        },
    },
};
</script>
<style scoped>
</style>
